const test = [
    {
        "code": "TAF-IB110006",
        "category": "IB",
        "name": "檢驗機構認證規範ISO/IEC 17020與ILAC-P15訓練",
        "classDate": "2021/10/28~2021/10/29",
        "studentQualification": "適用於欲瞭解或準備檢驗機構認證之學員。",
        "firstCourse": "",
        "enrollment": "50",
        "enrollmentStatus": "accept",
        "enrollmentType": "enrollment",
        "location": "線上",
        "cost": "新台幣5500",
        "description": "ISO/IEC 17020 “General requirements for the operation of various types of bodies performing inspection ” 為檢驗機構依據建立管理及接受認證之國際標準，廣泛為國際認證機構採用，並簽署國際相互承認協議。 " +
            "配合國內對檢驗機構認證之需求及國際之發展，TAF於2004年7月開放檢驗機構之認證服務，經認證之檢驗機構廣為權責機關及社會大眾所採用，接受其提供之檢驗/檢查服務。" +
            "本課程將邀請具有檢驗機構運作及訓練經驗之專家，以流程思考的邏輯，為您完整介紹ISO/IEC 17020之條文及國際實驗室認證聯盟(ILAC)所出版之ILAC-P15檢驗機構認證規範ISO/IEC 17020之應用文件，並對TAF於ISO/IEC 17020之認證要求及應用詳加說明。" +
            "受訓完者，回至崗位可充分運用上課所獲知識，建立符合ISO/IEC 17020標準之運作系統。\n" + "\n" +
            "全程參加且經測驗合格者，可獲頒本會ISO/IEC 17020訓練合格證書。\n" +
            "(註)本會並無登錄及授權其它訓練機構核發TAF訓練證書。",
        "outline": "● 檢驗機構之定義及工作範疇。\n" +
            "● 檢驗機構在國際間之發展情勢。\n" +
            "● 檢驗機構之分類(Type A/B/C) 。\n" +
            "● ISO/IEC 17020 之架構。\n" +
            "● ISO/IEC 17020及ILAC-P15 條文詮釋討論及應用。\n" +
            "● 如何準備 ISO/IEC 17020之認證。\n" +
            "● 課後測驗。",
        "remark": "★實體課程，請注意下列事項\n" +
            "1.疫情期間，將視疫情狀況調整人數。\n" +
            "2.本會將於開課前2週e-mail通知學員告知是否開課及收費，若因故無法開課，本會擁有取消或延期課程之權利。\n" +
            "3.若學員已報名但無法參加本課程，請儘速通知TAF訓練業務同仁。\n" +
            "4.參訓人員如遇補課、補考及補繳照片情形，需於三個月內申請完成，逾期將不再受理；如參加非例行性課程遇缺課情形，請於下次課程辦理時申請完成補課(含考試)，其餘(補考及補繳照片)亦依規定於三個月內申請完成。\n" +
            "\n" +
            "★遠距教學課程，請注意下列事項\n" +
            "1. 此次課程採Microsoft Teams進行。\n" +
            "2. 請於網站報名時提供完整報名資訊，以利視訊會議中進行查核員身分辨識。\n" +
            "3. 硬體需求:具備視訊鏡頭、音訊裝置及麥克風之筆記型電腦或桌上型電腦。\n" +
            "4. 將於課前E-mail課程連結網址。課程當日請提前半小時進入視訊教室，並以「姓名+公司簡稱」或「姓名(以個人名義參訓者)」進入視訊會議大廳，如與報名資料不一致將無法進入教室。視訊課程將會有管制入場機制。\n" +
            "5. 最後一天課程結束後，隨即進行線上測驗。\n" +
            "6. 為尊重智慧財產權，線上課程進行期間，不可翻拍或錄影。\n" +
            "7. 線上課程同一帳號僅限本人使用，不得將參加課程活動之權利轉讓予他人。\n" +
            "8. 線上課程恕不接受補課。\n" +
            "9. 線上課程費用為$5,200(含稅)。"
    },
    {
        "code": "TAF-IB110005",
        "category": "IB",
        "name": "檢驗機構認證規範ISO/IEC 17020與ILAC-P15訓練",
        "classDate": "2021/11/09~2021/11/10",
        "studentQualification": "適用於欲瞭解或準備檢驗機構認證之學員。",
        "firstCourse": "",
        "enrollment": "50",
        "enrollmentStatus": "accept",
        "enrollmentType": "enrollment",
        "location": "線上",
        "cost": "新台幣5500",
        "description": "ISO/IEC 17020 “General requirements for the operation of various types of bodies performing inspection ” 為檢驗機構依據建立管理及接受認證之國際標準，廣泛為國際認證機構採用，並簽署國際相互承認協議。 " +
            "配合國內對檢驗機構認證之需求及國際之發展，TAF於2004年7月開放檢驗機構之認證服務，經認證之檢驗機構廣為權責機關及社會大眾所採用，接受其提供之檢驗/檢查服務。" +
            "本課程將邀請具有檢驗機構運作及訓練經驗之專家，以流程思考的邏輯，為您完整介紹ISO/IEC 17020之條文及國際實驗室認證聯盟(ILAC)所出版之ILAC-P15檢驗機構認證規範ISO/IEC 17020之應用文件，並對TAF於ISO/IEC 17020之認證要求及應用詳加說明。" +
            "受訓完者，回至崗位可充分運用上課所獲知識，建立符合ISO/IEC 17020標準之運作系統。\n" + "\n" +
            "全程參加且經測驗合格者，可獲頒本會ISO/IEC 17020訓練合格證書。\n" +
            "(註)本會並無登錄及授權其它訓練機構核發TAF訓練證書。",
        "outline": "● 檢驗機構之定義及工作範疇。\n" +
            "● 檢驗機構在國際間之發展情勢。\n" +
            "● 檢驗機構之分類(Type A/B/C) 。\n" +
            "● ISO/IEC 17020 之架構。\n" +
            "● ISO/IEC 17020及ILAC-P15 條文詮釋討論及應用。\n" +
            "● 如何準備 ISO/IEC 17020之認證。\n" +
            "● 課後測驗。",
        "remark": "★實體課程，請注意下列事項\n" +
            "1.疫情期間，將視疫情狀況調整人數。\n" +
            "2.本會將於開課前2週e-mail通知學員告知是否開課及收費，若因故無法開課，本會擁有取消或延期課程之權利。\n" +
            "3.若學員已報名但無法參加本課程，請儘速通知TAF訓練業務同仁。\n" +
            "4.參訓人員如遇補課、補考及補繳照片情形，需於三個月內申請完成，逾期將不再受理；如參加非例行性課程遇缺課情形，請於下次課程辦理時申請完成補課(含考試)，其餘(補考及補繳照片)亦依規定於三個月內申請完成。\n" +
            "\n" +
            "★遠距教學課程，請注意下列事項\n" +
            "1. 此次課程採Microsoft Teams進行。\n" +
            "2. 請於網站報名時提供完整報名資訊，以利視訊會議中進行查核員身分辨識。\n" +
            "3. 硬體需求:具備視訊鏡頭、音訊裝置及麥克風之筆記型電腦或桌上型電腦。\n" +
            "4. 將於課前E-mail課程連結網址。課程當日請提前半小時進入視訊教室，並以「姓名+公司簡稱」或「姓名(以個人名義參訓者)」進入視訊會議大廳，如與報名資料不一致將無法進入教室。視訊課程將會有管制入場機制。\n" +
            "5. 最後一天課程結束後，隨即進行線上測驗。\n" +
            "6. 為尊重智慧財產權，線上課程進行期間，不可翻拍或錄影。\n" +
            "7. 線上課程同一帳號僅限本人使用，不得將參加課程活動之權利轉讓予他人。\n" +
            "8. 線上課程恕不接受補課。\n" +
            "9. 線上課程費用為$5,200(含稅)。"
    },
]

export default test;